import React, { useMemo } from 'react'
import './ProgramFilters.scss'
import useI18n from '../../../i18n/useI18n'
import RoleBasedAccess from '../../../components/role-based-access'
import { UserTypeEnum } from '../../../utils/enums'

const ProgramFilters = ({
  filters,
  onFilterChange,
  availableDegreeLevels = [],
  availableLanguages = [],
  onBulkUpdateClick
}) => {
  const { t } = useI18n()
  // Derece filtrelerini hazırla
  const degreeLevels = useMemo(() => {
    const degreeLabels = {
      'lisans': t('PROGRAM_FILTERS_DEGREE_LISANS'),
      'önlisans': t('PROGRAM_FILTERS_DEGREE_ONLISANS'),
      'onlisans': t('PROGRAM_FILTERS_DEGREE_ONLISANS'),
      'master': t('PROGRAM_FILTERS_DEGREE_MASTER'),
      'yüksek lisans': t('PROGRAM_FILTERS_DEGREE_MASTER'),
      'doktora': t('PROGRAM_FILTERS_DEGREE_DOKTORA')
    }

    return availableDegreeLevels.map(degree => ({
      value: degree.toLowerCase(),
      label: degreeLabels[degree.toLowerCase()] || degree
    }))
  }, [availableDegreeLevels, t])

  // Dil filtrelerini hazırla
  const languages = useMemo(() => {
    const languageLabels = {
      'türkçe': { label: t('COMMON_LANGUAGES_TR'), flag: '🇹🇷' },
      'turkce': { label: t('COMMON_LANGUAGES_TR'), flag: '🇹🇷' },
      'ingilizce': { label: t('COMMON_LANGUAGES_EN'), flag: '🇬🇧' },
      'i̇ngilizce': { label: t('COMMON_LANGUAGES_EN'), flag: '🇬🇧' },
      'english': { label: t('COMMON_LANGUAGES_EN'), flag: '🇬🇧' }
    }

    return availableLanguages.map(lang => {
      const langLower = lang.toLowerCase()
      const langInfo = languageLabels[langLower] || { label: lang, flag: '' }
      return {
        value: langLower,
        label: langInfo.label,
        flag: langInfo.flag
      }
    })
  }, [availableLanguages, t])

  const handleDegreeClick = (value) => {
    onFilterChange({
      ...filters,
      degreeLevel: filters.degreeLevel === value ? null : value
    })
  }

  const handleLanguageClick = (value) => {
    const currentLanguages = filters.languages || []
    const newLanguages = currentLanguages.includes(value)
      ? currentLanguages.filter(lang => lang !== value)
      : [...currentLanguages, value]

    onFilterChange({
      ...filters,
      languages: newLanguages
    })
  }

  const handleSearchChange = (e) => {
    onFilterChange({
      ...filters,
      search: e.target.value
    })
  }

  return (
    <div className="program-filters-section">
      <div className="container-fluid">
        <div className="filters-header">
          <h2 className="filters-title">{t('PROGRAM_FILTERS_TITLE')}</h2>
          <RoleBasedAccess allowedRoles={[UserTypeEnum.ADMIN]}>
            {onBulkUpdateClick && (
              <button
                className="btn btn-primary btn-round btn-simple"
                onClick={onBulkUpdateClick}
              >
                <i className="zmdi zmdi-edit m-r-5" style={{ fontSize: '16px' }}></i>
                {t('PROGRAM_FEES_BULK_UPDATE_TITLE')}
              </button>
            )}
          </RoleBasedAccess>
        </div>

        <div className="filters-content">
          <div className="filters-row">
            {/* Derece Seviyesi Filtresi - Sadece veri varsa göster */}
            {degreeLevels.length > 0 && (
              <div className="filter-group filter-group-inline">
                <label className="filter-group-label">{t('PROGRAM_FILTERS_DEGREE_LABEL')}</label>
                <div className="filter-buttons">
                  {degreeLevels.map((level) => (
                    <button
                      key={level.value}
                      className={`filter-btn filter-btn-sm ${filters.degreeLevel === level.value ? 'active' : ''}`}
                      onClick={() => handleDegreeClick(level.value)}
                    >
                      {level.label}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Dil Filtresi - Sadece veri varsa göster */}
            {languages.length > 0 && (
              <div className="filter-group filter-group-inline">
                <label className="filter-group-label">{t('PROGRAM_FILTERS_LANGUAGE_LABEL')}</label>
                <div className="filter-buttons">
                  {languages.map((lang) => (
                    <button
                      key={lang.value}
                      className={`filter-btn filter-btn-sm ${(filters.languages || []).includes(lang.value) ? 'active' : ''}`}
                      onClick={() => handleLanguageClick(lang.value)}
                    >
                      {lang.flag && <span className="flag-icon">{lang.flag}</span>}
                      {lang.label}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Arama Alanı - Her zaman göster */}
            <div className="filter-group filter-group-search">
              <div className="search-input-wrapper">
                <i className="zmdi zmdi-search search-icon"></i>
                <input
                  type="text"
                  className="search-input"
                  placeholder={t('PROGRAM_FILTERS_SEARCH_PLACEHOLDER')}
                  value={filters.search || ''}
                  onChange={handleSearchChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProgramFilters
